import React from 'react';

/**
 * EmptyState component for consistent empty state styling
 * Provides consistent messaging and optional actions
 */
const EmptyState = ({ 
  icon,
  title,
  description,
  action,
  className = '',
  ...props 
}) => {
  return (
    <div className={`text-center py-6 ${className}`} {...props}>
      {icon && (
        <div className="text-6xl mb-4 opacity-50">
          {icon}
        </div>
      )}
      {title && (
        <h3 className="text-xl font-semibold text-text-primary mb-2">
          {title}
        </h3>
      )}
      {description && (
        <p className="text-text-secondary mb-4 max-w-md mx-auto">
          {description}
        </p>
      )}
      {action && (
        <div className="mt-4">
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
